import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

export interface DialogData {
  title: string;
  text: string;
}

@Component({
  selector: 'app-open-dialog-text',
  templateUrl: './open-dialog-text.component.html',
  styleUrls: ['./open-dialog-text.component.scss']
})
export class OpenDialogTextComponent implements OnInit {

  constructor(
    public dialogRef: MatDialogRef<OpenDialogTextComponent>,
    @Inject(MAT_DIALOG_DATA) public data: DialogData
  ) { }

  ngOnInit(): void {
  }

}
